export default __webpack_public_path__ + "mockup_app_bienvenida.2b4728c.svg";